<template>
  <sidebar
  :addTitle="$t('GradeControl.Employee.AddNew')"
  :editTitle="$t('GradeControl.Employee.Edit')"
  :isSidebarActive="isSidebarActive"
  :data="data"
  @onNewData="newData"
  @onEditData="editData"
  @closeSidebar="closeSidebar">
    <ValidationObserver ref="observer">
      <div class="p-6">
        <vs-row class="mb-3">
          <vs-col vs-w="12">
            <ValidationProvider :name="$t('GradeControl.Employee.Code')" rules="required" v-slot="{ errors }">
              <validated-input
              :disabled="employeeId !== 0"
              :label="$t('GradeControl.Employee.Code')"
              v-model="code"
            ></validated-input>
            <validation-message>{{ errors[0] }}</validation-message>
            </ValidationProvider>
          </vs-col>
        </vs-row>
        <vs-row class="mb-3">
          <vs-col vs-w="5" class="mr-5">
            <ValidationProvider :name="$t('GradeControl.Employee.FirstName')" rules="required" v-slot="{ errors }">
              <validated-input
              :label="$t('GradeControl.Employee.FirstName')"
              v-model="firstName"
            ></validated-input>
            <validation-message>{{ errors[0] }}</validation-message>
            </ValidationProvider>
          </vs-col>
          <vs-col vs-w="6" >
            <ValidationProvider :name="$t('GradeControl.Employee.LastName')" rules="required" v-slot="{ errors }">
              <validated-input
              :label="$t('GradeControl.Employee.LastName')"
              v-model="lastName"
            ></validated-input>
            <validation-message>{{ errors[0] }}</validation-message>
            </ValidationProvider>
          </vs-col>
        </vs-row>
        <vs-row class="mb-3">
          <vs-col vs-w="12">
            <vs-checkbox v-model="isActive" class="mb-2">{{$t('GradeControl.Employee.IsActive')}}</vs-checkbox>
          </vs-col>
        </vs-row>
      </div>
    </ValidationObserver>
    <template v-slot:footer>
      <vs-button class="mr-6" @click="submitData">{{ $t('Submit') }}</vs-button>
      <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">{{ $t('Cancel') }}</vs-button>
    </template>
  </sidebar>
</template>

<script>
import {
  ValidatedInput,
  ValidationMessage,
  Sidebar
} from "./../../../../../shared/components";

export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    projectId: {
      type: Number,
      required: true
    },
    data: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    ValidatedInput,
    ValidationMessage,
    Sidebar
  },
  data() {
    return {
      employeeId: 0,
      code: "",
      firstName: "",
      lastName: "",
      isActive: true,
      settings: {
        // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: 0.6
      }
    };
  },
  computed: {
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive;
      },
      set(val) {
        if (!val) {
          this.closeSidebar();
        }
      }
    }
  },
  methods: {
    newData() {
      this.initValues();
      this.$refs.observer.reset();
    },
    editData() {
      const { employeeId, code, firstName, lastName, isActive } = JSON.parse(JSON.stringify(this.data));
      this.employeeId = employeeId;
      this.code = code;
      this.firstName = firstName;
      this.lastName = lastName;
      this.isActive = isActive;
      this.$refs.observer.reset();
    },
    closeSidebar() {
      this.$emit("closeSidebar");
    },
    initValues() {
      if (this.data.id) return;
     
      this.employeeId = 0;
      this.code = "";
      this.firstName = "";
      this.lastName = "";
      this.isActive = true;
    },
    
    submitData() {
      this.$refs.observer.validate().then(result => {
        if (result) {
          const obj = {
            employeeId: this.employeeId,
            code: this.code,
            firstName: this.firstName,
            lastName: this.lastName,
            projectId: this.projectId,
            isActive: this.isActive
          };

          this.$vs.loading();
          if (this.employeeId !== null && this.employeeId > 0) {
            this.$store.dispatch("gradeControl/updateEmployee", obj).then((result) => {
              this.$emit("onEmployeeUpdated", result.data.model);
            }).finally(() => {
              this.$vs.loading.close();
            });
          } else {
            this.$store.dispatch("gradeControl/addEmployee", obj).then((result) => {
              this.$emit("onEmployeeInserted", result.data.model);
            }).finally(() => {
              this.$vs.loading.close();
            });
          }
        }
      });
    }
  }
};
</script>
